import { gql } from '@apollo/client';

export const DELETE_LMI_PROOF_DOC_UPLOAD = gql`
  mutation Flex_DeleteLMIProofDocUpload($id: Int!) {
    deleteLMIProofDocUpload(id: $id) {
      id
    }
  }
`;
